var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 230,
    viewBox: "0 0 249 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1241_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 116,
    r: 114,
    fill: "#6AA8EE",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6406 74.293L125.025 57.8945L141.524 161.915L38.14 178.313L21.6406 74.293Z",
    fill: "white",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0879 90.7947L30.2539 72.9282",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2779 104.578L34.7324 101.133",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3164 71.0164L145.7 54.6179L162.2 158.638L58.8158 175.036L42.3164 71.0164Z",
    fill: "#B1B7BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3164 71.0164L145.7 54.6179L162.2 158.638L58.8158 175.036L42.3164 71.0164Z",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2017 176.402L44.7363 141.939",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.363 96.6056C154.103 107.573 160.128 117.4 169.114 123.925C178.099 130.449 189.309 133.138 200.276 131.398L96.8906 147.797C91.4603 148.658 85.9134 148.442 80.5668 147.159C75.2202 145.877 70.1785 143.554 65.7296 140.323C61.2807 137.092 57.5117 133.017 54.6378 128.33C51.7639 123.642 49.8414 118.435 48.9801 113.004L42.7744 73.8868C42.7144 73.5097 42.7293 73.1244 42.8182 72.7531C42.9072 72.3817 43.0685 72.0315 43.2928 71.7225C43.5172 71.4135 43.8002 71.1517 44.1257 70.9521C44.4513 70.7525 44.813 70.619 45.1902 70.5592L142.832 55.0722C143.209 55.0122 143.595 55.0271 143.966 55.1161C144.337 55.2051 144.687 55.3663 144.996 55.5907C145.305 55.815 145.567 56.098 145.767 56.4236C145.966 56.7492 146.1 57.1108 146.16 57.488L152.363 96.6056Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.281 83.4902L46.8955 99.889L42.7705 73.8868C42.7105 73.5097 42.7254 73.1244 42.8143 72.7531C42.9033 72.3817 43.0646 72.0315 43.2889 71.7225C43.5132 71.4135 43.7963 71.1517 44.1218 70.9521C44.4474 70.7525 44.8091 70.619 45.1863 70.5592L142.831 55.0722C143.208 55.0122 143.593 55.0271 143.965 55.1161C144.336 55.2051 144.686 55.3663 144.995 55.5907C145.304 55.815 145.566 56.098 145.766 56.4236C145.965 56.7492 146.099 57.1108 146.158 57.488L150.281 83.4902Z",
    fill: "#6AA8EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152.363 96.6056C154.103 107.573 160.128 117.4 169.114 123.925C178.099 130.449 189.309 133.138 200.276 131.398L96.8906 147.797C91.4603 148.658 85.9134 148.442 80.5668 147.159C75.2202 145.877 70.1785 143.554 65.7296 140.323C61.2807 137.092 57.5117 133.017 54.6378 128.33C51.7639 123.642 49.8414 118.435 48.9801 113.004L42.7744 73.8868C42.7144 73.5097 42.7293 73.1244 42.8182 72.7531C42.9072 72.3817 43.0685 72.0315 43.2928 71.7225C43.5172 71.4135 43.8002 71.1517 44.1257 70.9521C44.4513 70.7525 44.813 70.619 45.1902 70.5592L142.832 55.0722C143.209 55.0122 143.595 55.0271 143.966 55.1161C144.337 55.2051 144.687 55.3663 144.996 55.5907C145.305 55.815 145.567 56.098 145.767 56.4236C145.966 56.7492 146.1 57.1108 146.16 57.488L152.363 96.6056Z",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6762 58.0803C92.9209 59.7053 93.3568 61.2957 93.975 62.8184L99.9495 61.8729C99.1802 60.4004 98.6597 58.8109 98.4091 57.1686C97.9994 54.5623 98.2409 51.895 99.1121 49.4047C99.9833 46.9144 101.457 44.6783 103.402 42.8958C105.347 41.1132 107.703 39.8397 110.26 39.1886C112.817 38.5376 115.495 38.5292 118.056 39.1644C120.616 39.7995 122.98 41.0584 124.936 42.8287C126.892 44.5991 128.38 46.826 129.267 49.3108C130.154 51.7957 130.412 54.4614 130.018 57.0702C129.625 59.679 128.592 62.1499 127.012 64.2627C126.762 64.576 126.579 64.9368 126.473 65.323C126.367 65.7092 126.341 66.1129 126.396 66.5096C126.488 67.0771 126.746 67.6047 127.137 68.0261C127.529 68.4476 128.035 68.7442 128.594 68.8788C129.153 69.0133 129.74 68.9798 130.28 68.7825C130.82 68.5851 131.29 68.2327 131.63 67.7695C133.744 64.982 135.151 61.7242 135.732 58.2746C136.313 54.8249 136.05 51.2859 134.965 47.96C133.249 42.7666 129.644 38.4073 124.866 35.7456C120.088 33.0839 114.484 32.314 109.164 33.5882C103.845 34.8625 99.1986 38.088 96.1449 42.626C93.0912 47.1639 91.8532 52.6833 92.6762 58.0907V58.0803Z",
    fill: "white",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0831 63.0911C61.3282 64.716 61.7641 66.3064 62.3819 67.8291L68.3564 66.8836C67.5871 65.4112 67.0666 63.8216 66.816 62.1793C66.4073 59.5734 66.6496 56.9068 67.5213 54.4172C68.3929 51.9276 69.8669 49.6923 71.8119 47.9105C73.7569 46.1287 76.1125 44.8557 78.6687 44.2049C81.225 43.5541 83.9025 43.5458 86.4627 44.1807C89.023 44.8156 91.3864 46.0739 93.3424 47.8437C95.2984 49.6134 96.7863 51.8395 97.6734 54.3236C98.5605 56.8078 98.8193 59.4728 98.4268 62.0812C98.0343 64.6896 97.0026 67.1604 95.4236 69.2734C95.1763 69.5751 94.9923 69.9236 94.8826 70.2981C94.773 70.6725 94.7401 71.0652 94.7857 71.4527C94.8314 71.8402 94.9547 72.2145 95.1484 72.5532C95.342 72.892 95.602 73.1881 95.9127 73.4241C96.2235 73.66 96.5786 73.8309 96.9569 73.9264C97.3352 74.0219 97.7289 74.0402 98.1144 73.9801C98.4999 73.92 98.8693 73.7827 99.2005 73.5766C99.5318 73.3704 99.8181 73.0995 100.042 72.7802C102.156 69.9927 103.563 66.735 104.144 63.2853C104.725 59.8357 104.462 56.2967 103.378 52.9707C101.661 47.7774 98.0565 43.4181 93.2781 40.7564C88.4996 38.0947 82.8958 37.3247 77.5766 38.599C72.2574 39.8732 67.6107 43.0988 64.557 47.6367C61.5033 52.1747 60.2653 57.694 61.0883 63.1015L61.0831 63.0911Z",
    fill: "white",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4939 68.1017C29.7378 69.7269 30.1738 71.3174 30.7927 72.8398L36.7672 71.8943C35.9979 70.4218 35.4774 68.8323 35.2268 67.19C34.815 64.5829 35.0549 61.9144 35.9252 59.4225C36.7955 56.9307 38.269 54.693 40.2143 52.9092C42.1597 51.1253 44.5163 49.8507 47.0741 49.199C49.6318 48.5474 52.311 48.539 54.8728 49.1746C57.4345 49.8102 59.7991 51.0701 61.7556 52.8417C63.7121 54.6134 65.1996 56.8418 66.0854 59.3281C66.9712 61.8145 67.2279 64.4814 66.8324 67.0911C66.4369 69.7007 65.4016 72.1718 63.8189 74.2841C63.5715 74.5858 63.3875 74.9343 63.2779 75.3087C63.1683 75.6832 63.1353 76.0759 63.181 76.4634C63.2266 76.8509 63.3499 77.2252 63.5436 77.5639C63.7372 77.9026 63.9972 78.1988 64.3079 78.4347C64.6187 78.6707 64.9738 78.8415 65.3521 78.9371C65.7304 79.0326 66.1241 79.0508 66.5096 78.9907C66.8951 78.9306 67.2645 78.7934 67.5957 78.5872C67.927 78.381 68.2133 78.1102 68.4374 77.7909C70.5533 75.004 71.963 71.7464 72.546 68.2963C73.1291 64.8461 72.8683 61.3062 71.7858 57.9788C70.0692 52.7854 66.4647 48.4261 61.6863 45.7644C56.9078 43.1027 51.304 42.3328 45.9848 43.607C40.6656 44.8813 36.0189 48.1068 32.9652 52.6448C29.9115 57.1827 28.6736 62.702 29.4965 68.1095L29.4939 68.1017Z",
    fill: "white",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9004 99.889L150.283 83.4902",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3516 95.377L77.3491 107.97C79.0551 118.991 85.0498 128.89 94.0255 135.508C103.001 142.126 114.23 144.926 125.262 143.298",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.445 91.2363L103.349 103.248C105.104 114.385 111.168 124.386 120.231 131.092C129.295 137.799 140.631 140.673 151.795 139.095",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M128.562 86.9346L130.357 98.2368C133.971 121.028 154.302 137.526 176.335 135.196",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1797 121.309L153.287 102.435",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4277 138.529L163.462 118.997",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5801 195.913C69.5801 196.51 70.7757 197.101 73.0987 197.652C75.4217 198.204 78.8266 198.705 83.119 199.127C87.4113 199.549 92.5071 199.884 98.1153 200.112C103.724 200.341 109.734 200.458 115.805 200.458C121.875 200.458 127.886 200.341 133.494 200.112C139.102 199.884 144.198 199.549 148.491 199.127C152.783 198.705 156.188 198.204 158.511 197.652C160.834 197.101 162.029 196.51 162.029 195.913C162.029 195.316 160.834 194.724 158.511 194.173C156.188 193.621 152.783 193.12 148.491 192.698C144.198 192.276 139.102 191.941 133.494 191.713C127.886 191.484 121.875 191.367 115.805 191.367C109.734 191.367 103.724 191.484 98.1153 191.713C92.5071 191.941 87.4113 192.276 83.119 192.698C78.8266 193.12 75.4217 193.621 73.0987 194.173C70.7757 194.724 69.5801 195.316 69.5801 195.913Z",
    fill: "#3B4B52",
    fillOpacity: 0.15
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M195.737 1.78912C188.369 2.49016 181.271 4.93824 175.028 8.93219C168.784 12.9261 163.572 18.352 159.821 24.7638C156.07 31.1757 153.886 38.3906 153.449 45.8157C153.012 53.2408 154.334 60.6641 157.307 67.4758L146.022 93.4002C145.843 93.8105 145.785 94.2634 145.854 94.7057C145.923 95.148 146.117 95.5612 146.411 95.897C146.706 96.2328 147.09 96.4771 147.518 96.6013C147.946 96.7254 148.4 96.7243 148.827 96.598L175.68 88.6594C182.001 92.5684 189.157 94.9101 196.557 95.4913C203.956 96.0724 211.387 94.8764 218.236 92.0018C225.085 89.1273 231.155 84.6567 235.946 78.9593C240.736 73.2618 244.11 66.5009 245.787 59.2347C247.465 51.9685 247.399 44.4054 245.594 37.17C243.79 29.9346 240.298 23.2343 235.409 17.6224C230.519 12.0105 224.372 7.64788 217.474 4.89484C210.576 2.1418 203.125 1.07726 195.737 1.78912Z",
    fill: "white",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M201.723 52.0158C201.618 52.4281 201.379 52.7936 201.044 53.0547C200.708 53.3158 200.295 53.4575 199.871 53.4575C199.446 53.4575 199.033 53.3158 198.698 53.0547C198.362 52.7936 198.123 52.4281 198.018 52.0158C190.528 22.4968 190.852 23.8353 190.823 23.5308C190.718 22.2774 190.874 21.0158 191.281 19.8258C191.688 18.6358 192.337 17.5433 193.187 16.6175C194.038 15.6916 195.071 14.9526 196.221 14.447C197.372 13.9415 198.614 13.6804 199.871 13.6804C201.127 13.6804 202.37 13.9415 203.52 14.447C204.67 14.9526 205.703 15.6916 206.554 16.6175C207.404 17.5433 208.053 18.6358 208.46 19.8258C208.867 21.0158 209.023 22.2774 208.918 23.5308C208.889 23.8262 209.204 22.4877 201.723 52.0158Z",
    fill: "#B1B7BA",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M208.95 69.0227C208.95 70.7329 208.418 72.4048 207.42 73.8268C206.422 75.2488 205.004 76.3572 203.345 77.0116C201.686 77.6661 199.86 77.8374 198.099 77.5037C196.338 77.1701 194.72 76.3465 193.45 75.1372C192.181 73.9278 191.316 72.3871 190.965 70.7097C190.615 69.0323 190.795 67.2936 191.482 65.7135C192.169 64.1335 193.333 62.783 194.826 61.8328C196.319 60.8826 198.075 60.3755 199.871 60.3755C202.279 60.3755 204.588 61.2865 206.291 62.9082C207.994 64.5299 208.95 66.7293 208.95 69.0227Z",
    fill: "#B1B7BA",
    stroke: "#3B4B52",
    strokeWidth: 2.59762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1241_2",
    x: 0,
    y: 2,
    width: 228,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1241_2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.def3ad7f18e9db22ffa8b9916a4a3ca7.svg";
export { ForwardRef as ReactComponent };